module.exports = __webpack_public_path__ + "static/media/practofexc2022.6048c7e2.png";